import React, { useState } from 'react';
import Modal from '../../components/Modal/Modal';
import Input from '../../components/Inputs/Input/Input';
import Button from '../../components/Button/Button';
import createModel from '../../api/cars/createModel';
import alert from '../../helpers/alert';

// ÐÐ¾Ð¼Ð¿Ð°ÐºÑÐ½Ð°Ñ Ð¼Ð¾Ð´Ð°Ð»ÐºÐ° Ð´Ð¾Ð±Ð°Ð²Ð»ÐµÐ½Ð¸Ñ Ð¼Ð¾Ð´ÐµÐ»Ð¸ Ð¿ÑÑÐ¼Ð¾ Ð¸Ð· ÑÐ¾ÑÐ¼Ñ Ð¿ÑÐ°Ð²ÐºÐ¸ ÑÑÑÐ¾ÐºÐ¸ ÑÑÐ¾ÐºÐ° â
// ÑÑÐ¾Ð±Ñ Ð½Ðµ Ð·Ð°ÑÑÐ°Ð²Ð»ÑÑÑ Ð¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»Ñ Ð¸Ð´ÑÐ¸ Ð½Ð° Ð¾ÑÐ´ÐµÐ»ÑÐ½ÑÑ ÑÑÑÐ°Ð½Ð¸ÑÑ /cars/models Ð¸
// Ð²Ð¾Ð·Ð²ÑÐ°ÑÐ°ÑÑÑÑ, ÐµÑÐ»Ð¸ Ð¼Ð¾Ð´ÐµÐ»Ñ Ð¸Ð· ÑÐ°Ð¹Ð»Ð° Ð¿ÑÐ¾ÑÑÐ¾ Ð¾ÑÑÑÑÑÑÐ²ÑÐµÑ Ð² ÑÐ¿ÑÐ°Ð²Ð¾ÑÐ½Ð¸ÐºÐµ
const AddModelModal = ({ isOpen, onClose, markId, markLabel, initialName, onCreated }) => {
  const [name, setName] = useState(initialName || '');
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    if (!markId) {
      alert.error('Ð¡Ð½Ð°ÑÐ°Ð»Ð° Ð²ÑÐ±ÐµÑÐ¸ÑÐµ Ð¼Ð°ÑÐºÑ');
      return;
    }
    const trimmed = name.trim();
    if (!trimmed) {
      alert.error('ÐÐ²ÐµÐ´Ð¸ÑÐµ Ð½Ð°Ð·Ð²Ð°Ð½Ð¸Ðµ Ð¼Ð¾Ð´ÐµÐ»Ð¸');
      return;
    }
    setSaving(true);
    try {
      // ÐÐ¾Ð½ÑÑÐ¾Ð»Ð»ÐµÑ (CarsController.createModel) Ð½Ð° ÑÑÐ¿ÐµÑÐµ Ð¾ÑÐ´Ð°ÑÑ { markId }, Ð° Ð½Ðµ
      // { code, result } â Ð½Ð° Ð¾ÑÐ¸Ð±ÐºÐµ (Ð¼Ð¾Ð´ÐµÐ»Ñ ÑÐ¶Ðµ ÑÑÑÐµÑÑÐ²ÑÐµÑ Ð¸ Ñ.Ð¿.) ÑÑÐ¾ 400 Ñ
      // { errorMessage }, ÐºÐ¾ÑÐ¾ÑÑÐ¹ axios Ð¿ÑÐ¾ÐºÐ¸Ð´ÑÐ²Ð°ÐµÑ ÐºÐ°Ðº Ð¸ÑÐºÐ»ÑÑÐµÐ½Ð¸Ðµ
      const response = await createModel({ markId, name: trimmed });
      const newModelId = Number(response?.data?.markId);
      if (!newModelId) {
        alert.error('ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ Ð´Ð¾Ð±Ð°Ð²Ð¸ÑÑ Ð¼Ð¾Ð´ÐµÐ»Ñ');
        return;
      }
      alert.success('ÐÐ¾Ð´ÐµÐ»Ñ Ð´Ð¾Ð±Ð°Ð²Ð»ÐµÐ½Ð°');
      onCreated({ value: newModelId, label: trimmed });
      onClose();
    } catch (err) {
      alert.error(err?.response?.data?.errorMessage || 'ÐÑÐ¸Ð±ÐºÐ° Ð¿ÑÐ¸ Ð´Ð¾Ð±Ð°Ð²Ð»ÐµÐ½Ð¸Ð¸ Ð¼Ð¾Ð´ÐµÐ»Ð¸');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      title="ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ Ð¼Ð¾Ð´ÐµÐ»Ñ"
      width="480px"
      contentStyle={{ top: '18%', bottom: 'auto' }}
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
        {markLabel && (
          <div style={{ fontFamily: "'Exo 2', sans-serif", fontSize: 13, color: '#8a8272' }}>
            ÐÐ°ÑÐºÐ°: <strong>{markLabel}</strong>
          </div>
        )}
        <Input
          label="ÐÐ°Ð·Ð²Ð°Ð½Ð¸Ðµ Ð¼Ð¾Ð´ÐµÐ»Ð¸"
          placeholder="ÐÐ°Ð¿ÑÐ¸Ð¼ÐµÑ, Soluto"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
        />
        <Button text="ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ" fill onClick={handleSave} disabled={saving} />
      </div>
    </Modal>
  );
};

export default AddModelModal;
